import React from 'react';
import reduxFetch from 'react-redux-fetch';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import apiRoutes from '../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch(() => [
    {
      resource: 'vehicleByLicensePlate',
      method: 'get',
      request: licensePlate => ({
        url: addParametersToUri(apiRoutes.vehicleLicensePlate(), { licensePlate }),
        clearValueOnRequest: true,
      }),
    },
  ])(props => <ComposedComponent {...props} />);
